import React from 'react';
import 'react-quill/dist/quill.snow.css';
import downloadFile from './secret_file.rtf'
import {
    MDBInput,
    MDBCol,
    MDBRow,
    MDBCheckbox,
    MDBBtn,
    MDBIcon,
    MDBContainer,
    MDBTypography
} from 'mdb-react-ui-kit';

function SecretPage() {

    return (
        <>
            <MDBContainer className='d-flex justify-content-center align-items-center' style={{ height: '70vh' }}>
                <MDBBtn type='link' className='mb-4' href={downloadFile} download="ПРОТОКОЛЫ ОБСЛЕДОВАНИЯ ПРИМИТИВНЫХ РЕФЛЕКСОВ.rtf" size='lg' >
                    Скачать
                </MDBBtn>
            </MDBContainer>
        </>
    );

}

export default SecretPage;